import React, { useEffect, useRef, useMemo } from 'react'
import constants from 'constants'
import { getAuthToken } from 'utils/authSession'

const CAMPAIGNS_DOMAIN = constants.campaignsDomain

const CampaignsPage = () => {
  const iframeRef = useRef(null)

  const appConfig = useMemo(() => {
    try {
      const stored = sessionStorage.getItem('campaignsAppConfig')
      if (!stored) return null
      const config = JSON.parse(stored)
      return {
        appId: config.appId || '',
        region: config.region || 'us',
        apiKey: config.apiKey || '',
        authToken: getAuthToken() || '',
      }
    } catch {
      return null
    }
  }, [])

  useEffect(() => {
    document.title = 'CometChat Campaigns'
  }, [])

  useEffect(() => {
    if (!appConfig) return undefined

    const handleMessage = event => {
      if (event.origin !== new URL(CAMPAIGNS_DOMAIN).origin) return
      if (event.data?.type === 'cometchat-campaigns-ready') {
        iframeRef.current?.contentWindow.postMessage(
          {
            type: 'cometchat-app-config',
            appId: appConfig.appId,
            region: appConfig.region,
            apiKey: appConfig.apiKey,
            authToken: appConfig.authToken,
          },
          new URL(CAMPAIGNS_DOMAIN).origin,
        )
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [appConfig])

  if (!appConfig) {
    return (
      <div
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}
      >
        <p>Unable to load campaigns. Please open this page from the dashboard sidebar.</p>
      </div>
    )
  }

  return (
    <iframe
      ref={iframeRef}
      src={CAMPAIGNS_DOMAIN}
      title="CometChat Campaigns"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-downloads"
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
        display: 'block',
      }}
    />
  )
}

export default CampaignsPage
